import { render, staticRenderFns } from "./ModalPrices.vue?vue&type=template&id=7855e1e5&lang=pug&"
import script from "./ModalPrices.vue?vue&type=script&lang=js&"
export * from "./ModalPrices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports